import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  PayRatesHttpModel,
  PayRatesTouchlessHttpModel,
} from '../../http/dashboard/dashboard-http.models';
import { ErrorResponse } from '../../shared/shared-http.models';

export const PayRatesActions = createActionGroup({
  source: 'Pay Rates',
  events: {
    'Load Pay Rates': emptyProps(),
  },
});

export const PayRatesAPIActions = createActionGroup({
  source: 'Pay Rates API',
  events: {
    'Loaded Pay Rates Successfully': props<{
      payRates: PayRatesTouchlessHttpModel | PayRatesHttpModel;
    }>(),
    'Loaded Pay Rates Unsuccessfully': props<{
      error: ErrorResponse;
    }>(),
  },
});
